@if (!disableInput) {
  <mat-form-field class="item-filter">
    <mat-label>{{ "tocItem.filter" | translate }}</mat-label>
    <input title="Filter" (keyup)="onFilterChange()" [(ngModel)]="filter" matInput />
    <div matSuffix>
      @if (filter) {
        <button mat-icon-button matIconSuffix (click)="filter = ''; onFilterChange()">
          <mat-icon svgIcon="close" color="primary" />
        </button>
      }
      <ng-content select="[filters]"></ng-content>
    </div>
  </mat-form-field>
}

<div class="table-header">
  <mat-paginator
    #paginator
    [length]="dataSource?.data.length || 0"
    hidePageSize="true"
    [pageSize]="store.userItemsPerPage">
  </mat-paginator>
  <div class="actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
<ng-content select="[selectAll]"></ng-content>

<o-loading [isLoading]="!displayReady"></o-loading>
@if (displayReady && dataSource?.data.length === 0) {
  <div class="empty-message">
    {{ emptyMessage }}
  </div>
}
